/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
import moment from 'moment';

import {
  fetchPopulatedMailingList,
  updateMailingList,
} from 'root/apps/QuoteMachineIntegration/services/MailingListService';
import { MailingListType } from 'root/apps/QuoteMachineIntegration/state/MailingList';
import { datadogRum } from 'root/datadog/datadogRum';

class ControlsTreeSelect implements MerchantosControlsTreeSelect {
  scrollY = 0;

  selectNode: MerchantosControlsTreeSelect['selectNode'] = (inputId, nodeId) => {
    this.cancel();

    const input = $<HTMLInputElement>(`#${inputId}`)[0];

    if (!input) {
      return false;
    }
    input.value = nodeId;

    const hiddenInput = $<HTMLInputElement>(`#${input.id}_onchange`);
    if (hiddenInput.length) {
      $(hiddenInput).trigger('change');
    }

    const content_map = {} as ContentMap;
    content_map.form_name = 'controls.tree_select';
    content_map.node_id = nodeId;
    content_map.input_id = input.id;
    content_map.table_name = $(`#${input.id}_table_name`).val() as string;
    content_map.select_all = $(`#${input.id}_select_all`).val() as string;
    content_map.select_none = $(`#${input.id}_select_none`).val() as string;
    window.doServerCall(content_map, this.selectNodeCallback);

    return true;
  };

  selectNodeCallback: MerchantosControlsTreeSelect['selectNodeCallback'] = (result) => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'input_id' does not exist on type 'Partia... Remove this comment to see the full error message
    const input_div = $(`#${result.input_id}_content`)[0];
    if (!input_div) {
      return;
    }
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
    input_div.innerHTML = result.html;
  };

  edit = (inputId: string, nodeId: string, callbackAfterSelectorIsRendered?: () => void) => {
    const content_map = {} as ContentMap;
    content_map.form_name = 'controls.tree_select';
    content_map.edit = 'On';
    content_map.node_id = nodeId;
    content_map.input_id = inputId;
    // title, table_name, select_all and select_none are set by hidden elements on the item details page, for this classes' use with item fees we need to set a value if these elements are not in the DOM
    content_map.title = ($(`#${inputId}_title`).val() as string) ?? 'Category';
    content_map.table_name = ($(`#${inputId}_table_name`).val() as string) ?? 'category';
    content_map.select_all = ($(`#${inputId}_select_all`).val() as string) ?? 'Off';
    content_map.select_none = ($(`#${inputId}_select_none`).val() as string) ?? 'On';

    window.doServerCall(content_map, (result) => {
      this.editCallback(result);
      if (callbackAfterSelectorIsRendered) {
        callbackAfterSelectorIsRendered();
      }
    });
  };

  editCallback = (result: AjaxFormsResponse) => {
    const overlayContentHolderEl = $('#overlay_content_holder')[0];
    const overlayContentBlackoutEl = $('#overlay_content_black_out')[0];

    this.scrollY = window.scrollY;

    if (overlayContentHolderEl && overlayContentBlackoutEl) {
      overlayContentHolderEl.style.display = '';
      overlayContentBlackoutEl.style.display = '';
      overlayContentHolderEl.innerHTML = result?.html || '';
      this.scrollTop(0);
      return;
    }

    const overlayContentBlackoutHtml =
      "<div id='overlay_content_black_out' style='z-index: 1001; position: fixed; top: 0%; left: 0%; bottom: 0%; width: 100%; height: 100%; background-color: black; -moz-opacity: 0.8; opacity: .80; filter: alpha(opacity=80);'></div>";

    const overlayContentHolderHtml = `<div id='overlay_content_holder' style='z-index: 1002; position: absolute; top: 25px; left: 50%; width: 500px; margin-left: -250px; background-color: white; overflow: auto; font-family: arial;' class="category-selector">${result.html}</div>`;

    const ndiv = document.createElement('div');

    ndiv.innerHTML = `${overlayContentBlackoutHtml} ${overlayContentHolderHtml}`;
    document.body.appendChild(ndiv);
    this.scrollTop(0);
  };

  cancel = () => {
    $('#overlay_content_holder').hide();
    $('#overlay_content_black_out').hide();
    this.scrollTop(this.scrollY);
  };

  scrollTop = (newTop: number) => {
    if (!window.isGriffin()) {
      return;
    }
    window.scrollTo({ top: newTop, behavior: 'smooth' });
  };
}

class ControlsPreventRepeatHolder implements MerchantosControlsPreventRepeatHolder {
  control: MerchantosControlsPreventRepeatHolder['control'];

  disabled: MerchantosControlsPreventRepeatHolder['disabled'];

  enabled: MerchantosControlsPreventRepeatHolder['enabled'];

  constructor(
    control: MerchantosControlsPreventRepeatHolder['control'],
    force_time_limit?: number
  ) {
    this.control = control;
    this.disabled = false;
    this.enabled = false;
    this.control.disabled = true;

    if (force_time_limit) {
      this.disabled = true;
      setTimeout(() => this.expireDisabled(), force_time_limit * 1000);
    }
  }

  isDisabled = () => {
    if (this.control.disabled) {
      return true;
    }
    return false;
  };

  enable = () => {
    if (this.disabled) {
      this.enabled = true;
      return;
    }
    this.control.disabled = false;
  };

  expireDisabled = () => {
    this.disabled = false;
    if (this.enabled) {
      this.control.disabled = false;
    }
  };
}

class ControlsPreventRepeat implements MerchantosControlsPreventRepeat {
  actions_fired: MerchantosControlsPreventRepeat['actions_fired'];

  attach_to_next_server_call: string | number | undefined;

  holder: MerchantosControlsPreventRepeatHolderConstructor;

  constructor() {
    this.actions_fired = {};
    this.holder = ControlsPreventRepeatHolder;
  }

  preventIt: MerchantosControlsPreventRepeat['preventIt'] = (control, force_time_limit) => {
    if (!control.prevent_repeat_id) {
      control.prevent_repeat_id = `id_${performance.now()}`;
    }
    if (
      this.actions_fired[control.prevent_repeat_id] &&
      this.actions_fired[control.prevent_repeat_id].isDisabled()
    ) {
      return true;
    }
    this.attach_to_next_server_call = control.prevent_repeat_id;
    // eslint-disable-next-line new-cap
    this.actions_fired[control.prevent_repeat_id] = new this.holder(control, force_time_limit);
    return false;
  };

  freeLast = () => {
    this.freeIt(this.attach_to_next_server_call);
  };

  freeIt = (control_prevent_id: TSFixMe) => {
    // is this a valid control prevent id?
    if (!control_prevent_id || !this.actions_fired[control_prevent_id]) {
      return;
    }

    // clear the lock on this id
    if (this.actions_fired[control_prevent_id]) {
      if (this.actions_fired[control_prevent_id].isDisabled()) {
        this.actions_fired[control_prevent_id].enable();
      }
      delete this.actions_fired[control_prevent_id];
    }
    // clear a pending lock
    if (this.attach_to_next_server_call === control_prevent_id) {
      this.attach_to_next_server_call = undefined;
    }
  };

  attachToServerCall = () => {
    // if we have nothing to attach do nothing
    if (!this.attach_to_next_server_call) {
      return false;
    }
    // use up the id we need to attach next
    const control_prevent_id = this.attach_to_next_server_call;
    this.attach_to_next_server_call = undefined;
    return control_prevent_id;
  };

  freeAll = () => {
    Object.keys(this.actions_fired).forEach((control_prevent_id) => {
      this.freeIt(control_prevent_id);
    });
    this.actions_fired = {};
    this.attach_to_next_server_call = undefined;
  };
}

class Controls implements MerchantosControls {
  tree_select: MerchantosControlsTreeSelect;

  prevent_repeat: MerchantosControlsPreventRepeat;

  constructor() {
    this.tree_select = new ControlsTreeSelect();
    this.prevent_repeat = new ControlsPreventRepeat();
  }

  remote_return = (result: AjaxFormsResponse) => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'content' does not exist on type 'Partial... Remove this comment to see the full error message
    if (result.content && result.content.length) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'content' does not exist on type 'Partial... Remove this comment to see the full error message
      const len = result.content.length;
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < len; i++) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'content' does not exist on type 'Partial... Remove this comment to see the full error message
        const content = result.content[i];
        // eslint-disable-next-line no-continue
        if (!content.id) continue;
        const ele = document.getElementById(content.id);
        // eslint-disable-next-line no-continue
        if (!ele) continue;
        if (content.type === 'insert') {
          ele.innerHTML = content.html;
        } else if (content.type === 'append') {
          ele.innerHTML += content.html;
        } else if (content.type === 'remove') {
          // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
          ele.parentNode.removeChild(ele);
        }
      }
    }
  };

  remote = (ele: TSFixMe) => {
    const content_map = {} as ContentMap;
    content_map.method = 'POST';
    content_map.form_name = 'controls.input';
    if (ele && ele.type) {
      if (ele.type === 'form' || ele.type === 'div' || ele.type === 'span') {
        content_map.values = window.getFormValues(ele);
      } else if (ele.value) {
        content_map.value = window.getFormFieldValue(ele) as string;
      }
    }
    content_map.name = ele.name;
    content_map.id = ele.id;
    window.doServerCall(content_map, window.merchantos.controls.remote_return);
  };

  customFunctionOnClick: MerchantosControls['customFunctionOnClick'] = (control, options) => {
    const deferred = $.Deferred<boolean, boolean, never>();
    if (!options.name) {
      return deferred.resolve(false).promise();
    }
    if (!options.pannel_id) {
      return deferred.resolve(false).promise();
    }
    if (!options.context) {
      return deferred.resolve(false).promise();
    }
    options.confirm_msg = options.confirm_msg ? options.confirm_msg : false;

    options.extra = typeof options.extra === 'undefined' ? null : options.extra;
    if (!options.asyncHook && options.asyncHookName && window.asyncHooks[options.asyncHookName]) {
      options.asyncHook = window.asyncHooks[options.asyncHookName];
    }

    // eslint-disable-next-line no-alert
    if (options.confirm_msg && !confirm(options.confirm_msg)) {
      return deferred.resolve(false).promise();
    }

    const pannel = window.getViewPannel(options.pannel_id!);

    if (window.lsCloud.Modules.hasModule('customers.invoicing_integration.free_tier')) {
      const archivingEmployee = control?.getAttribute('data-employee-archive-button');
      const employeeId = pannel?.view?.record_id?.toString();
      if (archivingEmployee && employeeId) {
        fetchPopulatedMailingList(MailingListType.ALL)
          .then((res) => {
            const mailingListExistsAndEmployeeIsSubscribed =
              res?.id && res?.recipients.some((employee) => employeeId === employee.employeeId);
            if (mailingListExistsAndEmployeeIsSubscribed) {
              updateMailingList(MailingListType.ALL, {
                unsubscribe: [{ employeeId }],
              });
            }
          })
          .catch((err) => {
            datadogRum.addError(err, {
              message: 'LS_INVOICING_ERROR: Could not adjust mailing list.',
              accountId: window.merchantos.account.id,
            });
          });
      }
    }

    if (options.prevent_repeat && window.merchantos.controls.prevent_repeat.preventIt(control)) {
      return deferred.resolve(false).promise();
    }

    const triggerContextField = document.getElementById('save_trigger_context');
    if (triggerContextField) {
      const clickedId = control.id;
      const contextValue =
        clickedId === 'po_cost_save_button_id' ? 'apply_changes' : 'default_save';
      triggerContextField.setAttribute('value', contextValue);
    }

    const extra_key_values: { [key: string]: any } = {};

    const cleanUp = () => {
      if (options.prevent_repeat) {
        window.merchantos.controls.prevent_repeat.freeLast();
      }
    };

    // Trigger a sequence of promises
    $.Deferred()
      .resolve()
      .promise()
      .then(() => {
        if (options.asyncHook && typeof options.asyncHook === 'function') {
          return options
            .asyncHook(pannel)
            .then((result = true) => {
              if (!result) throw new Error('Validation failed');
              if (typeof result === 'object') {
                Object.assign(extra_key_values, result);
              }
            })
            .catch((_err: Error) => {
              throw new Error('Validation failed');
            });
        }
      })
      .then(() => {
        switch (options.context) {
          case 'listing_function':
            return window.doListingFunction(options.pannel_id!, options.name!, -1);
          case 'listing':
            return window.doListingFunction(options.pannel_id!, options.name!, options.extra!);
          case 'view':
            return window.doViewFunction(options.pannel_id!, options.name!, extra_key_values);
          default:
            return false;
        }
      })
      .then((result) => {
        cleanUp();
        deferred.resolve(result);
      })
      .catch((_err: Error) => {
        cleanUp();
        deferred.resolve(false);
      });

    return deferred.promise();
  };
}

window.merchantos.controls = new Controls();

window.captureFieldOldValue = function callCustomFunction(field) {
  if (field) {
    field.oldValue = field.value;
  }
};

window.revertFieldToOldValue = function revertToOldValue(field, defaultValue = '') {
  field.value = field.oldValue ?? defaultValue;
};

window.parseNumberChange = function parseNumberChange(field, min, max) {
  if (field.value.length === 0) return;
  const numberValue = Number(field.value);
  if (isNaN(numberValue) || window.isValueOutOfRange(numberValue, min, max)) {
    return window.revertFieldToOldValue(field, '');
  }
  field.value = String(parseInt(String(numberValue), 10));
};

window.parsePercentChange = function parsePercentChange(field, min, max) {
  if (field.value.length === 0) return;
  const numberValue = Number(field.value.replace(new RegExp('%$'), ''));
  if (isNaN(numberValue) || window.isValueOutOfRange(numberValue, min, max)) {
    return window.revertFieldToOldValue(field, '');
  }
  field.value = String(parseFloat(String(numberValue)));
};

/**
 * Will return true if the value is out of range.
 * Will return false if the value is in range or no range is specified.
 * To maximize resilience, returns a falsy value (null) when the value cannot be used to validate its range.
 * Validating that the value is a proper number should be done before calling this function.
 */
window.isValueOutOfRange = function isOutOfRangeValue(value, min, max) {
  if (isNaN(value)) {
    return null;
  }
  if (min !== null && min !== undefined && value < min) {
    return true;
  }
  if (max !== null && max !== undefined && value > max) {
    return true;
  }
  return false;
};

/*
	A function to manage helpful higlighting of listing input fields.
	var field - the input field that changed.
	var fieldType - the type of data the field should contain.
	var cssClass - the class to Add / Remove from the parent td.
*/
window.manageHighlightClass = function manageHighlightClass(field, fieldType, cssClass) {
  let valid = false;
  let toCheck;
  switch (fieldType) {
    case 'number':
      toCheck = parseFloat(field.value) || false;
      valid = typeof toCheck === 'number';
      break;
    case 'string':
      toCheck = field.value;
      valid = typeof toCheck === 'string';
      if (valid) {
        valid = toCheck.length > 0;
      }
      break;
    default:
      break;
  }

  let targetParent = $(field).parent();

  while (!$(targetParent).is('td')) {
    targetParent = $(targetParent).parent();
  }

  if (valid) {
    targetParent.removeClass(cssClass);
  } else {
    targetParent.addClass(cssClass);
  }
};

window.setDefaultSearchValuePref = function setDefaultSearchValuePref(event) {
  const { value } = event.target;
  const selectedOptionLabel = event.target.options[event.target.selectedIndex].innerHTML;
  const searchInput = document.querySelector('#listing_customer_search');

  const existingPlaceholderText = searchInput
    ?.getAttribute('placeholder')
    ?.split('(')?.[0]
    ?.trim() as string;

  searchInput?.setAttribute(
    'placeholder',
    value != '' ? `${existingPlaceholderText} (${selectedOptionLabel})` : existingPlaceholderText
  );

  window.storePrefOnServer('customer.listings.customers', 'customer_search_intention', value, '');
};

// Uses moment.js to check if date is valid.  Could have false positives if
// a valid but non YYYY-MM-DD formatted date is pasted in.
window.parseDateField = function parseDateField(date) {
  if (date.value === '' || moment(date.value).toString() === 'Invalid date') {
    return '';
  }
  return date.value;
};

/**
 * Parses and validates the date and time, and finally saves it to hidden fields for submission.
 * @param hidden The hidden element where the value will be saved
 * @param date The date element
 * @param time The time element
 * @returns {boolean} If the combination worked with both date and time
 */
window.combineDateTime = function combineDateTime(hidden, date, time) {
  if (!window.isObjectValid(date)) {
    date = window.xGetElementById(date);
  }

  if (!window.isObjectValid(time)) time = window.xGetElementById(time);
  if (!window.isObjectValid(hidden)) hidden = window.xGetElementById(hidden);

  if (!window.isObjectValid(date) || !window.isObjectValid(time) || !window.isObjectValid(hidden))
    return;

  let isValid = true;
  // Check if date.value is a valid date.  If it is not a valid date we need
  // to save "", and revert date.value back to an empty string so
  // that the place holder can show up in the field.
  const dateCheck = window.parseDateField(date);
  if (dateCheck === '') {
    date.value = '';
    isValid = false;
  }

  // Convert the 12H AM/PM format displayed to the 24H time saved in the DB.
  // TimeValue will return a time of 00:00 for invalid times.a
  const timeValue = window.merchantos.time.convertTimeTo24Hours(time);
  if (timeValue === '') {
    time.value = '';
    isValid = false;
  }

  // We need both a valid date and time, or else it won't work
  if (dateCheck === '' || timeValue === '') {
    hidden.value = '';
  } else {
    hidden.value = `${dateCheck} ${timeValue}`;
  }

  // eslint-disable-next-line consistent-return
  return isValid;
};

window.validateFloat = function validateFloat(input, name, decs) {
  if (input.value.length <= 0) return;
  if (name === null) name = 'Number';
  if (decs === null) decs = 3;
  const val = input.value;

  input.value = String(Math.round(parseFloat(val) * 10 ** decs) / 10 ** decs);
};

window.validateMoney = function validateMoney(input) {
  if (input.value.length === 0) return;
  let val = input.value;
  // if there is anything but $,.,-,0-9 then make it $0.00
  // eslint-disable-next-line no-useless-escape
  if (val.match(/([^\,\$\d\.\-\+])+/)) {
    input.value = '$0.00';
    window.setFocus(input);
    return;
  }
  val = String(window.getMoney(val));
  input.value = val;
};

window.validateMoneyForDisplay = function validateMoneyForDisplay(input, min, max) {
  const cleanNumber = window.stripNonNumbersFromString(input.value);

  if (window.isValueOutOfRange(Number(cleanNumber), min, max)) {
    window.revertFieldToOldValue(input, '0.00');
    return;
  }

  const money = window.formatMoney(cleanNumber, true);
  if (money === '0.00' && Number(input.value) !== 0) {
    window.revertFieldToOldValue(input, '0.00');
  } else {
    input.value = money;
  }
};

window.stripNonNumbersFromString = function stripNonNumbersFromString(str) {
  let canAddPeriod = true;

  return str.replace(/[^0-9]/g, (match, position) => {
    if (match === '.' && canAddPeriod) {
      canAddPeriod = false;
      return '.';
    }

    if (match === '-' && position === 0) {
      return '-';
    }

    return '';
  });
};

/**
 * Sets #id.value to input.value's pre-tax price using #id.data-tax-rate.
 * @param {Event} event
 * @param {Element} trans_line_id
 * @param {string} uniq_id
 */
window.updateTaxExclusivePrice = function updateTaxExclusivePrice(event, trans_line_id, uniq_id) {
  const $input = $(`#edit_item_price_${trans_line_id}`);

  const $exclusive = $(`#${uniq_id}`);

  const $checkbox = $(`#edit_item_tax_${trans_line_id}`);

  const input_val = isNaN(Number($input.val())) ? 0 : ($input.val() as number);

  const exclusive_val = $exclusive.val() as number;

  const tax_rate = parseFloat($exclusive.data('tax-rate'));

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'srcElement' does not exist on type 'Chan... Remove this comment to see the full error message
  const event_target = event.target || event.srcElement;

  // If this is a workorder line where the tax rate > 0
  // OR if this is a regular sale line where the "taxable" checkbox is checked
  if ((!$checkbox.length || $checkbox.prop('checked')) && tax_rate) {
    // Is taxable, and has a tax rate: update the TE price
    if (event_target === $checkbox[0]) {
      // This was triggered by re-enabling taxable, so update TI to TE * tax
      $input.val((exclusive_val * (1 + tax_rate)).toFixed(2));
    } else {
      // Calculate the TE price, then set it to max 5 decimal places, and then trim off extra 0s beyond 2 places
      $exclusive.val(
        ((input_val / (tax_rate * 100 + 100)) * 100).toFixed(5).replace(/(\.[0-9]{2})0*$/, '$1')
      );
    }
  } else if (event_target === $checkbox[0]) {
    // We just unchecked the taxable box: update the TI price
    $input.val(parseFloat(String(exclusive_val)).toFixed(2));
  } else {
    // Not taxable, or no tax rate
    $exclusive.val(parseFloat(String(input_val)).toFixed(2));
  }
};

window.getMoney = function getMoney(value) {
  value = String(value);
  if (isNaN(Number(value)) && value.length > 15) {
    return 0.0;
  }
  // eslint-disable-next-line no-useless-escape
  value = value.replace(/\,/gi, '');
  // eslint-disable-next-line no-useless-escape
  value = value.replace(/([^0-9\.\-])/g, '');
  const num = Number(value);
  if (isNaN(num)) {
    return 0.0;
  }
  if (num > 99999999) {
    return 0.0;
  }
  return Math.round(num * 100) / 100;
};

window.formatMoney = function formatMoney(value, hideSymbol) {
  const money = window.getMoney(value);
  const currencySymbol = hideSymbol ? '' : window.merchantos.locale.currency_symbol;
  const moneyTwoDecimals = parseFloat(String(money)).toFixed(2).toString();

  return currencySymbol + moneyTwoDecimals;
};

window.cb_addvalidationoption = function cb_addvalidationoption(result) {
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'Partial<{ na... Remove this comment to see the full error message
  if (!result.id || !result.name || !result.value) return;
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'Partial<{ na... Remove this comment to see the full error message
  const id = result.id;
  const name = result.name;
  const value = result.value;

  const sel = window.xGetElementById(id);
  if (!sel) return;
  if (!sel.options) return;
  const op = new Option(name, value);

  const i = sel.options.length;

  op.setAttribute('notranslate', '');

  sel.options[i] = op;
  sel.selectedIndex = i;
  if (sel.onchange()) sel.onchange();
};

window.addValidationOption = function addValidationOption(
  sel,
  pannel_id,
  table_name,
  name_field,
  title,
  extra,
  value_column
) {
  if (!sel.options) return false;
  if (sel.options[sel.selectedIndex].value !== '__new') return false;

  // eslint-disable-next-line no-alert
  const name = prompt(`Enter new ${title}`);
  if (!name) {
    window.selectListDefault(sel);
    return true;
  }
  if (name.length <= 0) {
    window.selectListDefault(sel);
    return true;
  }

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < sel.options.length; i++) {
    if (name === sel.options[i].value) {
      sel.selectedIndex = i;
      // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
      if (sel.onchange) sel.onchange();
      return false;
    }
  }

  const content_map = {} as ContentMap;
  content_map.method = 'POST';
  content_map.form_name = 'addvalidationoption';
  content_map.select_id = sel.id;
  content_map.pannel_id = pannel_id;
  content_map.table_name = table_name;
  // @ts-expect-error ts-migrate(2322) FIXME: Type 'HTMLInputElement' is not assignable to type ... Remove this comment to see the full error message
  content_map.name_field = name_field;
  content_map.name = name;
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'extra_values' does not exist on type 'Co... Remove this comment to see the full error message
  content_map.extra_values = extra;
  if (value_column) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'value_column' does not exist on type 'Co... Remove this comment to see the full error message
    content_map.value_column = value_column;
  }
  window.doServerCall(content_map, window.cb_addvalidationoption);

  return true;
};

window.selectListDefault = function selectListDefault(sel) {
  if (sel.length <= 0) return false;

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < sel.options.length; i++) {
    if (sel.options[i].defaultSelected) {
      sel.selectedIndex = i;
      return true;
    }
  }
  sel.selectedIndex = 0;
  return true;
};
